import PropTypes from 'prop-types';

import pricesByMonthShape from './pricesByMonth';

export default {
  type: PropTypes.string.isRequired,
  minimumPrice: PropTypes.number,
  fixedPrice: PropTypes.number,
  pricesByMonth: PropTypes.shape(pricesByMonthShape)
};
